// Polyfill for iOS Safari WebGPU
// This must be imported BEFORE any three.js WebGPU modules
if (typeof window !== 'undefined' && typeof GPUShaderStage === 'undefined' && navigator.gpu) {
  window.GPUShaderStage = {
    VERTEX: 0x1,
    FRAGMENT: 0x2,
    COMPUTE: 0x4
  }
}

export default true
